import { render } from "./MealPreparationGroups-add.vue?vue&type=template&id=29639fda"
import script from "./MealPreparationGroups-add.vue?vue&type=script&lang=js"
export * from "./MealPreparationGroups-add.vue?vue&type=script&lang=js"

import "./MealPreparationGroups-add.vue?vue&type=style&index=0&id=29639fda&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__